import { Component } from '@angular/core';

@Component({
  selector: 'indianpix-footer-container',
  templateUrl: './footer-container.component.html',
  styleUrls: ['./footer-container.component.scss'],
})
export class FooterContainerComponent {
  footerMenu = [
    { manuName: 'Home', link: '/' },
    { manuName: 'Service', link: '/services' },
    { manuName: 'Portfolio ', link: '/portfolio' },
    { manuName: 'Career ', link: '/career' },
    { manuName: 'Contact ', link: '/contact' },
  ];
}
